import { Tabs } from "antd";
import { useGetUserAdvertStatus } from "../ServerSideStates";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store/Reducers";
import { handleSetPortofolioFilter } from "../ClientSideStates";
import { useEffect } from "react";

const StatusTabFilters = () => {
    const status = useGetUserAdvertStatus();
    const {userInfoes} = useSelector((state:RootState)=>state.profile)
    const dispatch = useDispatch()
    const { filter } = useSelector((state: RootState) => state.portofolio);
    const handleOnChangeTab = (key:string)=>{
        const currentFilter = {...filter}
        if(key==="all")
        {
            delete currentFilter["Status"]
        }
        else{
            currentFilter["Status"] = key
        }
           dispatch(handleSetPortofolioFilter({ filter: currentFilter }));
    }

    useEffect(()=>{
        if(userInfoes?.id)
        {
            status.refetch()
        }
    },[userInfoes?.id])

    
    const items = [
        {
            key: "all",
            label: (
                <span>
                    Tüm İlanlarım <span className="text-gray-400">({status?.data?.data?.reduce((acc:any, item:any) => acc + item.count, 0) || 0})</span>
                </span>
            ),
        },
        ...(status?.data?.data?.filter((item:{ statusId: string; statusName: string; count: number })=>item.statusId!=="5")?.map((item: { statusId: string; statusName: string; count: number }) => ({
            key: item.statusId,
            label: (
                <span>
                    {item.statusName} <span className="text-gray-400">({item.count})</span>
                </span>
            ),
        })) || []),
    ];

    return <Tabs defaultActiveKey="all" items={items} onChange={handleOnChangeTab} />;
};

export default StatusTabFilters;
